<!-- Main Container -->
<main class="site-content fix-height">
  <div class="container login">
    <!-- Logo -->
    <div class="logo">
      <img src="/assets/images/qunote-logo-g.svg" alt="qunote">
    </div>
    <!-- Error Message Display Div -->
    <div class="alert-message">
      <!-- <div class="alert alert-dismissible fade in" role="alert" *ngIf="showMessageDiv" [ngClass]="msgtype?'alert-success':'alert-danger'">
        {{showmessage}}
      </div> -->
      <p-message closable *ngFor="let msg of msgs" [severity]="msg.severity" [text]="msg.summary"></p-message>
    </div>
    <!-- Form Headding -->
    <div class="form-heading">
      <h1>{{'login.title' | translate}}</h1>
    </div>
    <!-- Form Start -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" id="Login" class="front">
      <!-- Email Area -->
      <div class="input-row">
        <div class="input-field">
          <input type="email" #emailFocus class="input" id="inputEmail"
            placeholder="{{'login.email.placeholder' | translate}}" formControlName="email"
            [ngClass]="{'is-invalid':  f.email.errors && f.email.dirty }">
          <!-- Email Validations and Error Message -->
          <div *ngIf="f.email.errors && f.email.dirty" class="invalid-feedback">
            <div *ngIf="f.email.errors.required" class="error-message-form">{{'login.email.required' | translate}}</div>
            <div *ngIf="(f.email.errors.email || f.email.invalid) && f.email.value" class="error-message-form">
              {{ 'login.email.valid' | translate}}</div>
            <!-- <div *ngIf="(f.email.errors.maxlength)" class="error-message-form">
            Email must not exceed 100 characters</div> -->
          </div>
        </div>
      </div>
      <!-- Password Area -->
      <div class="input-row">
        <div class="input-field">
          <input type="password" class="input" id="inputPassword"
            placeholder="{{'login.password.placeholder' | translate}}" formControlName="password"
            [ngClass]="{'is-invalid':  f.password.errors && f.password.dirty }" (copy)="disablePaste($event)">
          <!-- Password Validations and Error Message -->
          <div *ngIf="f.password.errors && f.password.dirty" class="invalid-feedback">
            <div *ngIf="f.password.errors.required" class="error-message-form">{{'login.password.required' | translate}}
            </div>
            <div *ngIf="f.password.errors.minlength" class="error-message-form">{{'login.password.valid' | translate}}
            </div>
          </div>
        </div>
      </div>
      <!-- Buttons -->
      <div class="btns">
        <button class="btn btn-secondary btn-block submit" type="submit" [disabled]="!loginForm.valid"
          [style.display]="submitted?'none':''">
          {{'login.btn' | translate}}
        </button>
        <input type="button" name="" class="btn btn-link btn-block" routerLink="/forget-password"
          value="{{'login.forget' | translate}}">
      </div>
    </form>
    <!-- Signup Link -->
    <div class="front front-cta">
      <div class="front-txt">
        {{'login.signup' | translate}}
      </div>
      <br />
      <button routerLink="/signup" type="button" class="btn btn-primary">
        {{'login.signup_btn' | translate}}
      </button>
    </div>
  </div>
  <!-- Modal For Delete Confirmation -->
  <p-dialog [focusOnShow]="false" header="{{'activeSession' | translate}}" [closable]="false" [(visible)]="displayLogout" [modal]="true" 
    [draggable]="false" [blockScroll]="true" class="modal-logout">
    {{contentLogout}}
    <div  >
      <div class="btns">
        <input class="btn btn-primary cancel" name="cancel" type="button" value="{{'cancel' | translate}}"
          (click)="onCancelModal()">
        <input class="btn btn-primary save" name="submit" type="button"
          value="{{'navigation.user_section.logout' | translate}}" (click)="onConfirmnation()">
      </div>
    </div>
  </p-dialog>
</main>